import { takeEvery, takeLatest } from 'redux-saga/effects';
import { createHashedTaasData, StreckenTarifierer } from '@ps20-frontend/preis-lib';
import { App } from '@ps20-frontend/frontend-models';
import {
  StreckenTarifierungRequestEvents,
  TARIF_CHECKED,
  ZUSATZOPTION_CHECKED,
  ZUSATZOPTION_UNCHECKED,
} from '@ps20-frontend/shop-integration-redux';
import { ForkEffect } from '@redux-saga/core/effects';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { TaasGegeData } from '@ps20/bff-models';
import { IAppState } from '../appState';
import { GegeActions } from '../gegeActions';
import { buildTaasGegeDataForStrecke } from './transformer/gegeData.transformer';

export let streckenTarifierer: StreckenTarifierer<IAppState, TaasGegeData>;

const TARIFIERUNG_SUCCESS_ACTIONS = [
  StreckenTarifierungRequestEvents.PREISE_REQUESTED_SUCCESSFUL_MIT_INFO_GEGE,
  StreckenTarifierungRequestEvents.PREISE_REQUESTED_SUCCESSFUL_OHNE_INFO_GEGE,
];

export function* streckenTarifierungGEGE(): Generator<ForkEffect> {
  const requestActions = [
    TARIF_CHECKED,
    ZUSATZOPTION_CHECKED,
    ZUSATZOPTION_UNCHECKED,
    GegeActions.PREISE_REQUESTED,
    GegeActions.SELBSTBETEILIGUNG_CHANGED,
    GegeActions.GEGENSTAND_REMOVED,
  ];
  streckenTarifierer = new StreckenTarifierer(
    {
      appId: App.GEGE,
      successEventWithInfo:
        StreckenTarifierungRequestEvents.PREISE_REQUESTED_SUCCESSFUL_MIT_INFO_GEGE,
      successEventWithoutInfo:
        StreckenTarifierungRequestEvents.PREISE_REQUESTED_SUCCESSFUL_OHNE_INFO_GEGE,
      errorEvent: StreckenTarifierungRequestEvents.PREISE_REQUESTED_FAILED_GEGE,
    },
    buildTaasGegeDataForStrecke,
    undefined,
    createHashedRelevantRiskdataGege,
  );

  yield takeEvery(
    TARIFIERUNG_SUCCESS_ACTIONS,
    safeSaga(streckenTarifierer.handleSuccess, App.GEGE),
  );
  yield takeEvery(
    StreckenTarifierungRequestEvents.PREISE_REQUESTED_FAILED_GEGE,
    safeSaga(streckenTarifierer.handleError, App.GEGE),
  );
  yield takeLatest(requestActions, safeSaga(streckenTarifierer.callTarifierung, App.GEGE));
}

export function createHashedRelevantRiskdataGege(taasData: TaasGegeData): string {
  const relevantData = { ...taasData };
  delete relevantData.salesProducts;
  delete relevantData.spartenType;

  return createHashedTaasData(relevantData);
}
